export default __webpack_public_path__ + "static/media/rheumatological-icon.6ede36a4.svg";